import moment from 'moment';
import {
    FETCH_ALL_CONTRACTS,
    FETCH_COMPANY_CONTRACTS,
    FETCH_CUSTOMER_CONTRACTS,
    INSERT_CONTRACT,
    insertContract,
    CONTRACTS,
    UPDATE_CONTRACT,
    putOrInsertContract,
    putContract,
    setContracts,
    SIGN_CONTRACTS,
    PUT_CONTRACT,
    UPLOAD_DELIVERY_SLIP,
    updateContract,
    contractsApproved,
    UPDATE_UPDATE_SCHEDULE
} from '../../actions/contractsActions';
import {addNotificationMessage} from '../../actions/NotificationMessagesAction';
import {setLoading} from '../../LoadingActions';

import endpoints from '../../../endpoints';
import {apiRequest, GET, PUT, API_CALL_ERROR, API_CALL_SUCCESS} from '../../actions/ApiCallsActions';

import {getOrder} from '../../../api/network/orderService';
import {getDocumentData} from '../../../api/network/documentService';
import {
    getCustomerDocument,
    updateContractCall,
    updateCustomerDocument,
    uploadContract,
    getCommitment,
    getPromissory
} from '../../../api/network/businessCustomerService';
import {addNotification} from '../../actions/NotificationActions';
import {padString} from '../../../utils';
import {COMMITMENT_LETTER_STATUS, PROMISSORY_NOTE_STATUS, CONTRACT_STATUS} from '../../../utils/contracts';
import {NotificationGroups, NotificationMessageMethods} from '../../../components/AlertsHub';
import {DOCUMENT_TYPE, documentFileKeys} from '../../../const/documents';
import {createContract} from '../../../api/network/contractsService';
import {EventEmitter, EVENTS} from '../../../api/events';

const createNewContractAndUpdate = async (contract, newParams) => {
    console.log(`contract: ${Object.entries(contract)}`);
    const {id: contractId, companyId, customerId, documentId, representativeId} = contract;

    const documentRef = await getCustomerDocument(companyId, customerId, documentId);

    if (!documentRef || !documentRef.documentId) throw Error('Failed to find document id', documentRef);

    // TODO: do we want to delete this document id when the gk signed one is generated?

    // Get the document file
    const document = await getDocumentData(documentRef.documentId);

    if (!document || !document.data || !document.data.metadata) throw Error('Failed to get document');

    // pulling back content from already signed contract
    const args = document.data.metadata;

    const key = documentFileKeys.gkLeaseSigned;
    const params = {
        key,
        persist: true,
        args: {
            ...args,
            ...newParams
        }
    };

    // creating a new contract with signed gk signature on the business customer service.
    const newContractDocument = await createContract(params);

    if (!newContractDocument || !newContractDocument.headers || !newContractDocument.headers['custom-document-id'])
        throw Error('Something went wrong when creating new contract document');

    // use new documentId to update contract on business customer service
    // TODO consider creating a new document reference on the business customer
    await updateCustomerDocument(companyId, customerId, documentId, {
        documentId: newContractDocument.headers['custom-document-id'],
        documentTypeId: DOCUMENT_TYPE.Contracts
    });

    // finally updating contract object status
    const contractUpdateObject = {...contract};

    await updateContractCall(companyId, customerId, representativeId, contractId, contractUpdateObject);
};

export default ({dispatch, getState}) => next => async action => {
    next(action);

    if (!action.payload) return;
    const {type, payload} = action;

    // eslint-disable-next-line default-case
    switch (type) {
    case FETCH_ALL_CONTRACTS: {
        const url = endpoints.businessCustomerAllContracts();
        dispatch(apiRequest(url, GET, CONTRACTS));
        break;
    }
    case FETCH_CUSTOMER_CONTRACTS: {
        const {companyId, customerId} = action.payload;
        const url = endpoints.businessCustomerCustomerContracts(companyId, customerId);
        dispatch(apiRequest(url, GET, CONTRACTS));
        break;
    }
    case FETCH_COMPANY_CONTRACTS: {
        const {companyId} = action.payload;
        const url = endpoints.businessCustomerCompanyContracts(companyId);
        dispatch(apiRequest(url, GET, CONTRACTS));
        break;
    }

    case `${CONTRACTS} ${API_CALL_SUCCESS}`: {
        const {data} = action.payload;
        /*const getGkSignature = (item, data) => {
                    // Get the document reference
                    getCustomerDocument(item.companyId, item.customerId, item.documentId)
                        .then(result => {
                            if (result.documentId) {

                                // Get the document file
                                getDocumentData(result.documentId)
                                    .then(result => {
                                        // Get the meta data for signature on document
                                        if (result.data && result.data.metadata && result.data.metadata.gksignature) {
                                            item.gksignature = result.data.metadata.gksignature;
                                            dispatch(putOrInsertContract(item));
                                        } else {
                                            dispatch(putOrInsertContract(item));
                                        }
                                    })
                                    .catch(error => {
                                        console.error(error);
                                        dispatch(insertContract(item));
                                    });
                            }
                        })
                        .catch(error => {
                            console.error(error);
                            dispatch(insertContract(data));
                        });
                };*/

        data.map(item => {
            // Get the policies for contracts
            if (item.orderId)
                getOrder(item.orderId)
                    .then(result => {
                        // TODO: maybe find better way to include policies count on contract object
                        item.policies = result[0].items.reduce((acc, obj) => acc + obj.quantity, 0);
                        dispatch(putOrInsertContract(item));
                        // getGkSignature(item, data);
                    })
                    .catch(error => {
                        item.policies = 0;
                        dispatch(putOrInsertContract(item));
                        // getGkSignature(item, data);
                    });
        });

        // Normalising data
        const normalizedContracts = data.map(item => ({
            ...item,
            count: item.contractNumber,
            contractNumber: padString(item.contractNumber, 'C', 6)
        }));

        dispatch(setContracts(normalizedContracts));
        break;
    }
    case `${CONTRACTS} ${API_CALL_ERROR}`: {
        dispatch(addNotification('Failed to get Contracts', 'error'));
        break;
    }

    case SIGN_CONTRACTS: {
        /* Process for signing a contract */

        const {
            /*array of contracts*/
            data,
            meta,
        } = payload;

        dispatch(setLoading(type, true));

        // TODO change to promiseAll, because the time here will increase exponentially with the amount of contracts.
        for (const contract of data) { // looping through what happens if one of them fails?
            const {id: contractId, companyId, customerId, documentId, representativeId} = contract;

            // Get the document Ref so we can update
            try {
                console.log(`contract: ${Object.entries(contract)}`);
                // const documentRef = await getCustomerDocument(companyId, customerId, documentId);

                // if (!documentRef || !documentRef.documentId) throw Error('Failed to find document id', documentRef);

                // TODO: do we want to delete this document id when the gk signed one is generated?

                // Get the document file
                
                // const document = await getDocumentData(documentRef.documentId);
                // if (!document || !document.data || !document.data.metadata) throw Error('Failed to get document');

                // pulling back content from already signed contract

                // const {agday, agmonth, agyear, cfname, clname, caddress, csignature} = document.data.metadata;

                // const {user} = getState();
                // const agreementDate = moment();
                // const key = documentFileKeys.gkLeaseSigned;
                // const params = {
                //     key,
                //     persist: true,
                //     args: {
                //         agday: agday || '',
                //         agmonth: agmonth || '',
                //         agyear: agyear || '',
                //         cfname: cfname || '',
                //         clname: clname || '',
                //         caddress: caddress || '',
                //         csignature: csignature || '',
                //         gk_agday: agreementDate.format('D') || '',
                //         gk_agmonth: agreementDate.format('MMMM') || '',
                //         gk_agyear: agreementDate.format('YYYY') || '',
                //         gk_witness: `${user ? `${user.firstName || ''} ${user.lastName || ''}` : ''}`.trim() || '',
                //         gksignature: meta.signatureRef.toDataURL(),
                //         /*schedule: [
                //                 {
                //                     financed_amount: '$100,000.00',
                //                     terms: '3 MONTHS',
                //                     interest_rate: '10%',
                //                     description: 'iPhone XR 128GB BLUE',
                //                     colour: 'Blue',
                //                     model_number: 'IPXR128BLUE',
                //                     serial_number: '1234567890',
                //                     imei: '6574893021'
                //                 },
                //                 {
                //                     financed_amount: '$200,000.00',
                //                     terms: '3 MONTHS',
                //                     interest_rate: '10%',
                //                     description: 'iPhone XR 256GB GOLD',
                //                     colour: 'Gold',
                //                     model_number: 'IPXR256GOLD',
                //                     serial_number: '0987654321',
                //                     imei: '1023948756'
                //                 }
                //             ]*/
                //     }
                // };

                // creating a new contract with signed gk signature on the business customer service.
                // const newContractDocument = await createContract(params);

                // if (!newContractDocument || !newContractDocument.headers || !newContractDocument.headers['custom-document-id'])
                //     throw Error('Something went wrong when creating new contract document');

                // use new documentId to update contract on business customer service
                // TODO consider creating a new document reference on the business customer

                // await updateCustomerDocument(companyId, customerId, documentId, {
                //     documentId: newContractDocument.headers['custom-document-id'],
                //     documentTypeId: DOCUMENT_TYPE.Contracts
                // });

                // finally updating contract object status

                const contractUpdateObject = {...contract};
                contractUpdateObject.status = CONTRACT_STATUS.GK_SIGNED;

                await updateContractCall(companyId, customerId, representativeId, contractId, contractUpdateObject);

                contractUpdateObject.id = contractId;
                contractUpdateObject.gksignature = meta.signatureRef.toDataURL();

                //dispatch contract updated event.
                // TODO consider doing a bulk notification since multiple contract can be updated.
                dispatch(contractsApproved(contractUpdateObject));
                // sendContractUpdatedEvent(contractUpdateObject, putContract(contractUpdateObject));
                // dispatch(putContract(contractUpdateObject));

                await getCommitment(companyId, customerId, representativeId, contractId, {status: COMMITMENT_LETTER_STATUS.GENERATED});
                await getPromissory(companyId, customerId, representativeId, contractId, {status: PROMISSORY_NOTE_STATUS.GENERATED});
            } catch (error) {
                console.error('Something went wrong when tyring to sign the contracts', error);
                dispatch(addNotification('Failed to sign contract, please try again', 'error'));
            }
        }

        dispatch(setLoading(type, false));
        break;
    }
    case UPDATE_CONTRACT: {
        const {data, meta} = payload;
        const url = endpoints.businessCustomerCustomerContract(meta.companyId, meta.customerId, meta.repId, meta.contractId);
        const config = {headers: {'Content-Type': 'application/json'}};

        dispatch(apiRequest(url, PUT, UPDATE_CONTRACT, data, config, meta));
        break;
    }
    case UPDATE_UPDATE_SCHEDULE: {
        const {
            /*contract and schedule*/
            data
        } = payload;

        const {contract, schedule} = data;

        dispatch(setLoading(type, true));
        try {
            await createNewContractAndUpdate(contract, {schedule});
        } catch (e) {
            console.log('failed to updated contract');
        }

        dispatch(setLoading(type, false));
        break;
    }
    case `${UPDATE_CONTRACT} ${API_CALL_SUCCESS}`: {
        const {data, meta} = payload;
        //sendContractUpdatedEvent(data);
        dispatch(putContract(data));

        if (meta.eventAction) dispatch(meta.eventAction);
        break;
    }
    case `${UPDATE_CONTRACT} ${API_CALL_ERROR}`: {
        dispatch(addNotification('Failed to update Contract, Please try again', 'error'));
        break;
    }
    }
};
